import CustomerInformation from "@/core/interfaces/CustomerInformation";
import {TopSale} from "@/core/interfaces/sales/Sale";
import {NotificationTemplate} from "@/notification-template/interfaces";
import {ConversationMessage} from "@/conversation/interfaces";

export interface MassCertificationCustomerApiResponse {
    /** The customer id. */
    id: number;
    /** The customer information. */
    information: CustomerInformation;
    /** The customer last_visit */
    last_visit: string;
    /** The number of visits */
    visits: number;
    /** The last conversation message received. */
    last_conversation_message?: ConversationMessage;
    /** The last notification received. */
    last_notification?: string;
    /** If customer has notification disabled. */
    has_notification_disabled: boolean;
    /**
     * The customer top sales when requested.
     */
    top_sales?: TopSale[];
}

export interface MassCertificationCustomer {
    /** The customer id. */
    id: number;
    /** The customer last_visit */
    lastVisit?: string;
    /** The number of visits */
    visits?: number;
    /** The last certification notification received  */
    messageDate?: string;
    /** The customer phone. */
    phone?: string | null;
    /** The customer birth date. */
    birthDate?: string;
    /** The customer name. */
    name: string;
}

export interface MassCertificationNotificationBatchIndex {
    /** The message batch id. */
    id: number;
    /** The message batch created at value. */
    created_at: string;
    /** The number of messages in the batch */
    conversation_messages_count: number;
    /**
     * Number of messages in the batch that have been read.
     */
    read_conversation_messages_count?: number;
    /**
     * Number of messages where the customer interacted with.
     */
    reacted_conversation_messages_count?: number;
    /**
     * The notification template used for the batch.
     * Null if the batch was sent with custom content instead of a template.
     */
    template: NotificationTemplate | null;
}

/**
 * A distinct targetable of the organization batches, used by the batch index filter.
 */
export interface MassCertificationBatchTargetableOption {
    type: string;
    id: number;
    name: string;
}

export interface MassCertificationNotificationBatch extends MassCertificationNotificationBatchIndex {
    /** Customer content if any. */
    content: string | null;
    /** The content parsed. */
    parsed_content: string | null;
}

/**
 * Determine if the batch is of SMS type.
 */
export const isSMSBatch = (batch: MassCertificationNotificationBatchIndex) => {
    return !batch.template || batch.template.type === "sms";
};
